import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=13d30f12&"
import script from "./loadingIcon.vue?vue&type=script&lang=js&"
export * from "./loadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./loadingIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports